// Types
import { Country, Profile } from 'types'

export const value = <T>(key: string, def: T): T => {
  if (window && window.__env && window.__env.hasOwnProperty(key)) {
    return window.__env[key] as T
  }
  return def
}

export const DEFAULT_FETCH_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

export const HOSTNAME = value('HOSTNAME', '')
export const PROCESSED_MEDIA_URL = value('PROCESSED_MEDIA_URL', '')

export const API_ROOT = value('API_ROOT', 'http://localhost:8000')
export const COUNTRY = value('COUNTRY', 'COUNTRY')
export const ENCODED_AUDIO_ROOT = `${value('PROCESSED_MEDIA_URL', 'PROCESSED_MEDIA_URL')}snd/`
export const ENCODED_IMAGE_ROOT = `${value('PROCESSED_MEDIA_URL', 'PROCESSED_MEDIA_URL')}img/`
export const TRACKING_ENABLED = value('TRACKING_ENABLED', 0)
export const PIXELS_ENABLED = value('PIXELS_ENABLED', 0)
export const ADYEN_CLIENT_KEY = value('ADYEN_CLIENT_KEY', '')
export const ADYEN_ENVIRONMENT = value('ADYEN_ENVIRONMENT', '')
export const CDN_ROOT = value('CDN_ROOT', 'https://d2umolmz9zcmr8.cloudfront.net/unsafe/')
export const ASSET_PATH = value('ASSET_PATH', '')
export const SENTRY_DSN = value('SENTRY_DSN', '')
export const APP_SERVICE_SENTRY_ENABLED = value('APP_SERVICE_SENTRY_ENABLED', '')
export const APP_SERVICE_GTAG = value('APP_SERVICE_GTAG', '')
export const FB_APP_ID = value('FB_APP_ID', '')
export const FB_PIXEL_ID = value('FB_PIXEL_ID', '')
export const TWITTER_PIXEL_ID = value('TWITTER_PIXEL_ID', '')
export const BING_PIXEL_ID = value('BING_PIXEL_ID', '')
export const TIKTOK_PIXEL_ID = value('TIKTOK_PIXEL_ID', '')
export const TRACKLIB_IPI = '819694492'
export const TRACKLIB_CONTACT_SUPPORT_PAGE = 'https://support.tracklib.com/hc/en-us/requests/new'
export const TONE_SILENCE_LOGGING = value('TONE_SILENCE_LOGGING', 1)
export const IS_BETA = value('IS_BETA', false)
export const DEFAULT_FEATURE_TOGGLES = value('DEFAULT_FEATURE_TOGGLES', []) as Array<string>

export const FOOTERCONFIG = [
  {
    type: 'links',
    value: {
      links: [
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'ABOUT',
          url: '/about',
          page_id: 29,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'LEGAL',
          url: '/legal',
          page_id: 32,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'CONTACT US',
          url: '/contact',
          page_id: 26,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'Press',
          url: '/press',
          page_id: 27,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '1',
          disabled_for: '',
          text: 'Support',
          url: 'https://support.tracklib.com',
          page_id: null,
          open_in_new_tab: true,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'Blog',
          url: '/blog/',
          page_id: 4,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'Free downloads',
          url: '/blog/category/free-download',
          page_id: null,
          open_in_new_tab: false,
        },
      ],
    },
    id: 'c309c207-6a58-4e6d-8071-9d0f66184436',
  },
]
export const OTHERCONFIG = [
  {
    type: 'links',
    value: {
      links: [
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'Terms',
          url: '/terms',
          page_id: 36,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'cookies',
          url: '/cookies',
          page_id: 35,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'privacy',
          url: '/privacy',
          page_id: 34,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '1',
          disabled_for: '',
          text: 'collections',
          url: '/collections',
          page_id: 53,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'Referrals',
          url: '/referrals',
          page_id: 132,
          open_in_new_tab: false,
        },
        {
          loggedin_required: '0',
          disabled_for: '',
          text: 'Signup',
          url: '/signup',
          page_id: 143,
          open_in_new_tab: false,
        },
      ],
    },
    id: 'e37c6e4a-ab4a-464e-aff8-0086c79b0dab',
  },
]

/*

*/
export const TRACK_PRICE = value('TRACKPRICE', 1.99)
export const CURRENCY = value('CURRENCY', '$')
export const LICENSEPRICES = value('LICENSEPRICES', [
  { id: 3, category: 1, currency: 'EUR', price: '50.00' },
  { id: 2, category: 2, currency: 'EUR', price: '500.00' },
  { id: 1, category: 3, currency: 'EUR', price: '1500.00' },
  { id: 4, category: 1, currency: 'USD', price: '50.00' },
  { id: 6, category: 3, currency: 'USD', price: '1500.00' },
  { id: 5, category: 2, currency: 'USD', price: '500.00' },
  { id: 7, category: 1, currency: 'GBP', price: '50.00' },
  { id: 8, category: 2, currency: 'GBP', price: '500.00' },
  { id: 9, category: 3, currency: 'GBP', price: '1500.00' },
])

export const isAuthenticated = value('AUTHENTICATED', '')
export const FEATURE_TOGGLES = value('FEATURE_TOGGLES', [])
export const subscriptionLaunchDate = '2020-05-19'

export const SAMPLE_ID_FULL = 2
export const SAMPLE_ID_STANDARD = 1
export const SAMPLE_ID_ONESHOT = 3
export const SAMPLE_NAMES_IDS = {
  standard: SAMPLE_ID_STANDARD,
  full: SAMPLE_ID_FULL,
  short: SAMPLE_ID_ONESHOT,
}

export const SAMPLE_ID_NAMES = {
  [SAMPLE_ID_STANDARD]: 'Standard',
  [SAMPLE_ID_FULL]: 'Full',
  [SAMPLE_ID_ONESHOT]: 'Short',
}

export const PREVIEW_LIMIT = 30

const cCodes: Record<string, string> = { EUR: '€', USD: '$', GBP: '£' }
export const currencyCode = (currency: string) => cCodes[currency] || currency
export const getUrlToFile = (uri: string) =>
  uri.replace('static-sounds://', ENCODED_AUDIO_ROOT).replace('static-images://', ENCODED_IMAGE_ROOT)

export const DEFAULT_TRACK_TYPES = [17]

export const numberWithCommas = (x: number | string) => {
  const parts = x.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const formatPriceValue = (i: number | string, currency: string) =>
  `${currency}${numberWithCommas((+i).toFixed(2)).replace(/\.00$/, '')}`

export const formatPrice = (price: number, profile: Profile) => {
  return formatPriceValue(price, profile.currency)
}

const topLevelDomains = [
  'com',
  'com.au',
  'com.tw',
  'ca',
  'co',
  'co.nz',
  'co.uk',
  'de',
  'fr',
  'it',
  'ru',
  'net',
  'org',
  'edu',
  'gov',
  'jp',
  'nl',
  'kr',
  'se',
  'eu',
  'ie',
  'co.il',
  'us',
  'at',
  'be',
  'dk',
  'hk',
  'es',
  'gr',
  'ch',
  'no',
  'cz',
  'in',
  'net',
  'net.au',
  'info',
  'biz',
  'mil',
  'co.jp',
  'sg',
  'hu',
  'uk',
]

export const commonEmailMistakes = (email: string): string => {
  if (email) {
    const validTopLevelDomain = topLevelDomains.find(tld => email.endsWith(tld))
    if (!validTopLevelDomain) {
      return `Did you really mean "${email.split('@').pop()}"?`
    }
    if (email.includes('gnail')) {
      return 'Did you really mean "gnail"?'
    }
  }
  return ''
}

export const validateEmail = (email: string) => {
  if (!email) {
    return 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    return 'Invalid email address'
  }
  return false
}

export const getAdminHost = () => {
  if (window.location && window.location.hostname === 'localhost') {
    return 'https://admin.test.tracklib.com'
  }
  return 'http://web.admin.tracklib.com'
}

export const getCSSVariableByName = (variableName: string) =>
  window.getComputedStyle(document.body).getPropertyValue(variableName).toString()

export const isChrome = () => {
  const isChromium = window.chrome
  const winNav = window.navigator
  const vendorName = winNav.vendor
  const isOpera = typeof window.opr !== 'undefined'
  const isIEedge = winNav.userAgent.indexOf('Edge') > -1
  const isIOSChrome = winNav.userAgent.match('CriOS')

  if (isIOSChrome) {
    return false
  } else if (
    isChromium !== null &&
    typeof isChromium !== 'undefined' &&
    vendorName === 'Google Inc.' &&
    isOpera === false &&
    isIEedge === false
  ) {
    return true
  }
  return false
}

export const getYoutubeIdFromUrl = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#&?]*).*/
  const match = url.match(regExp)
  if (match && match[2].length === 11) {
    return match[2]
  }
  return ''
}

export const KEYS: { [id: string]: string } = {
  Gbm: 'G flat minor',
  Gb: 'G flat major',
  Gm: 'G minor',
  G: 'G major',
  Fm: 'F minor',
  F: 'F major',
  Ebm: 'E flat minor',
  Eb: 'E flat major',
  Em: 'E minor',
  E: 'E major',
  Dbm: 'D flat minor',
  Db: 'D flat major',
  Dm: 'D minor',
  D: 'D major',
  Cm: 'C minor',
  C: 'C major',
  Bbm: 'B flat minor',
  Bb: 'B flat major',
  Bm: 'B minor',
  B: 'B major',
  Abm: 'A flat minor',
  Ab: 'A flat major',
  Am: 'A minor',
  A: 'A major',
}

export const KEYS_CHOICES: Array<{ id: string; name: string }> = Object.keys(KEYS).map((keyId: string) => ({
  id: keyId,
  name: KEYS[keyId],
}))

export const CATEGORIES: { [id: number]: string } = {
  1: 'Category C',
  2: 'Category B',
  3: 'Category A',
}

export const CATEGORIES_CHOICES: Array<{
  id: number
  name: string
}> = Object.keys(CATEGORIES)
  .map(categoryId => ({ id: +categoryId, name: CATEGORIES[+categoryId] }))
  .sort((a, b) => a.name.localeCompare(b.name))

export const DEFAULT_EASE = [0.215, 0.61, 0.355, 1]

export const COUNTRIES: {
  [id: string]: Country
} = {
  AF: { id: 'AF', country_name: 'Afghanistan' },
  AX: { id: 'AX', country_name: 'Åland Islands' },
  AL: { id: 'AL', country_name: 'Albania' },
  DZ: { id: 'DZ', country_name: 'Algeria' },
  AS: { id: 'AS', country_name: 'American Samoa' },
  AD: { id: 'AD', country_name: 'Andorra' },
  AO: { id: 'AO', country_name: 'Angola' },
  AI: { id: 'AI', country_name: 'Anguilla' },
  AQ: { id: 'AQ', country_name: 'Antarctica' },
  AG: { id: 'AG', country_name: 'Antigua and Barbuda' },
  AR: { id: 'AR', country_name: 'Argentina' },
  AM: { id: 'AM', country_name: 'Armenia' },
  AW: { id: 'AW', country_name: 'Aruba' },
  AU: { id: 'AU', country_name: 'Australia' },
  AT: { id: 'AT', country_name: 'Austria' },
  AZ: { id: 'AZ', country_name: 'Azerbaijan' },
  BS: { id: 'BS', country_name: 'Bahamas' },
  BH: { id: 'BH', country_name: 'Bahrain' },
  BD: { id: 'BD', country_name: 'Bangladesh' },
  BB: { id: 'BB', country_name: 'Barbados' },
  BY: { id: 'BY', country_name: 'Belarus' },
  BE: { id: 'BE', country_name: 'Belgium' },
  BZ: { id: 'BZ', country_name: 'Belize' },
  BJ: { id: 'BJ', country_name: 'Benin' },
  BM: { id: 'BM', country_name: 'Bermuda' },
  BT: { id: 'BT', country_name: 'Bhutan' },
  BO: { id: 'BO', country_name: 'Bolivia' },
  BQ: { id: 'BQ', country_name: 'Bonaire, Sint Eustatius and Saba' },
  BA: { id: 'BA', country_name: 'Bosnia and Herzegovina' },
  BW: { id: 'BW', country_name: 'Botswana' },
  BV: { id: 'BV', country_name: 'Bouvet Island' },
  BR: { id: 'BR', country_name: 'Brazil' },
  IO: { id: 'IO', country_name: 'British Indian Ocean Territory' },
  BN: { id: 'BN', country_name: 'Brunei' },
  BG: { id: 'BG', country_name: 'Bulgaria' },
  BF: { id: 'BF', country_name: 'Burkina Faso' },
  BI: { id: 'BI', country_name: 'Burundi' },
  CV: { id: 'CV', country_name: 'Cabo Verde' },
  KH: { id: 'KH', country_name: 'Cambodia' },
  CM: { id: 'CM', country_name: 'Cameroon' },
  CA: { id: 'CA', country_name: 'Canada' },
  KY: { id: 'KY', country_name: 'Cayman Islands' },
  CF: { id: 'CF', country_name: 'Central African Republic' },
  TD: { id: 'TD', country_name: 'Chad' },
  CL: { id: 'CL', country_name: 'Chile' },
  CN: { id: 'CN', country_name: 'China' },
  CX: { id: 'CX', country_name: 'Christmas Island' },
  CC: { id: 'CC', country_name: 'Cocos (Keeling) Islands' },
  CO: { id: 'CO', country_name: 'Colombia' },
  KM: { id: 'KM', country_name: 'Comoros' },
  CG: { id: 'CG', country_name: 'Congo' },
  CD: { id: 'CD', country_name: 'Congo (the Democratic Republic of the)' },
  CK: { id: 'CK', country_name: 'Cook Islands' },
  CR: { id: 'CR', country_name: 'Costa Rica' },
  CI: { id: 'CI', country_name: "Côte d'Ivoire" },
  HR: { id: 'HR', country_name: 'Croatia' },
  CU: { id: 'CU', country_name: 'Cuba' },
  CW: { id: 'CW', country_name: 'Curaçao' },
  CY: { id: 'CY', country_name: 'Cyprus' },
  CZ: { id: 'CZ', country_name: 'Czechia' },
  DK: { id: 'DK', country_name: 'Denmark' },
  DJ: { id: 'DJ', country_name: 'Djibouti' },
  DM: { id: 'DM', country_name: 'Dominica' },
  DO: { id: 'DO', country_name: 'Dominican Republic' },
  EC: { id: 'EC', country_name: 'Ecuador' },
  EG: { id: 'EG', country_name: 'Egypt' },
  SV: { id: 'SV', country_name: 'El Salvador' },
  GQ: { id: 'GQ', country_name: 'Equatorial Guinea' },
  ER: { id: 'ER', country_name: 'Eritrea' },
  EE: { id: 'EE', country_name: 'Estonia' },
  ET: { id: 'ET', country_name: 'Ethiopia' },
  FK: { id: 'FK', country_name: 'Falkland Islands  [Malvinas]' },
  FO: { id: 'FO', country_name: 'Faroe Islands' },
  FJ: { id: 'FJ', country_name: 'Fiji' },
  FI: { id: 'FI', country_name: 'Finland' },
  FR: { id: 'FR', country_name: 'France' },
  GF: { id: 'GF', country_name: 'French Guiana' },
  PF: { id: 'PF', country_name: 'French Polynesia' },
  TF: { id: 'TF', country_name: 'French Southern Territories' },
  GA: { id: 'GA', country_name: 'Gabon' },
  GM: { id: 'GM', country_name: 'Gambia' },
  GE: { id: 'GE', country_name: 'Georgia' },
  DE: { id: 'DE', country_name: 'Germany' },
  GH: { id: 'GH', country_name: 'Ghana' },
  GI: { id: 'GI', country_name: 'Gibraltar' },
  GR: { id: 'GR', country_name: 'Greece' },
  GL: { id: 'GL', country_name: 'Greenland' },
  GD: { id: 'GD', country_name: 'Grenada' },
  GP: { id: 'GP', country_name: 'Guadeloupe' },
  GU: { id: 'GU', country_name: 'Guam' },
  GT: { id: 'GT', country_name: 'Guatemala' },
  GG: { id: 'GG', country_name: 'Guernsey' },
  GN: { id: 'GN', country_name: 'Guinea' },
  GW: { id: 'GW', country_name: 'Guinea-Bissau' },
  GY: { id: 'GY', country_name: 'Guyana' },
  HT: { id: 'HT', country_name: 'Haiti' },
  HM: { id: 'HM', country_name: 'Heard Island and McDonald Islands' },
  VA: { id: 'VA', country_name: 'Holy See' },
  HN: { id: 'HN', country_name: 'Honduras' },
  HK: { id: 'HK', country_name: 'Hong Kong' },
  HU: { id: 'HU', country_name: 'Hungary' },
  IS: { id: 'IS', country_name: 'Iceland' },
  IN: { id: 'IN', country_name: 'India' },
  ID: { id: 'ID', country_name: 'Indonesia' },
  IR: { id: 'IR', country_name: 'Iran' },
  IQ: { id: 'IQ', country_name: 'Iraq' },
  IE: { id: 'IE', country_name: 'Ireland' },
  IM: { id: 'IM', country_name: 'Isle of Man' },
  IL: { id: 'IL', country_name: 'Israel' },
  IT: { id: 'IT', country_name: 'Italy' },
  JM: { id: 'JM', country_name: 'Jamaica' },
  JP: { id: 'JP', country_name: 'Japan' },
  JE: { id: 'JE', country_name: 'Jersey' },
  JO: { id: 'JO', country_name: 'Jordan' },
  KZ: { id: 'KZ', country_name: 'Kazakhstan' },
  KE: { id: 'KE', country_name: 'Kenya' },
  KI: { id: 'KI', country_name: 'Kiribati' },
  KW: { id: 'KW', country_name: 'Kuwait' },
  KG: { id: 'KG', country_name: 'Kyrgyzstan' },
  LA: { id: 'LA', country_name: 'Laos' },
  LV: { id: 'LV', country_name: 'Latvia' },
  LB: { id: 'LB', country_name: 'Lebanon' },
  LS: { id: 'LS', country_name: 'Lesotho' },
  LR: { id: 'LR', country_name: 'Liberia' },
  LY: { id: 'LY', country_name: 'Libya' },
  LI: { id: 'LI', country_name: 'Liechtenstein' },
  LT: { id: 'LT', country_name: 'Lithuania' },
  LU: { id: 'LU', country_name: 'Luxembourg' },
  MO: { id: 'MO', country_name: 'Macao' },
  MK: { id: 'MK', country_name: 'Macedonia' },
  MG: { id: 'MG', country_name: 'Madagascar' },
  MW: { id: 'MW', country_name: 'Malawi' },
  MY: { id: 'MY', country_name: 'Malaysia' },
  MV: { id: 'MV', country_name: 'Maldives' },
  ML: { id: 'ML', country_name: 'Mali' },
  MT: { id: 'MT', country_name: 'Malta' },
  MH: { id: 'MH', country_name: 'Marshall Islands' },
  MQ: { id: 'MQ', country_name: 'Martinique' },
  MR: { id: 'MR', country_name: 'Mauritania' },
  MU: { id: 'MU', country_name: 'Mauritius' },
  YT: { id: 'YT', country_name: 'Mayotte' },
  MX: { id: 'MX', country_name: 'Mexico' },
  FM: { id: 'FM', country_name: 'Micronesia (Federated States of)' },
  MD: { id: 'MD', country_name: 'Moldova' },
  MC: { id: 'MC', country_name: 'Monaco' },
  MN: { id: 'MN', country_name: 'Mongolia' },
  ME: { id: 'ME', country_name: 'Montenegro' },
  MS: { id: 'MS', country_name: 'Montserrat' },
  MA: { id: 'MA', country_name: 'Morocco' },
  MZ: { id: 'MZ', country_name: 'Mozambique' },
  MM: { id: 'MM', country_name: 'Myanmar' },
  NA: { id: 'NA', country_name: 'Namibia' },
  NR: { id: 'NR', country_name: 'Nauru' },
  NP: { id: 'NP', country_name: 'Nepal' },
  NL: { id: 'NL', country_name: 'Netherlands' },
  NC: { id: 'NC', country_name: 'New Caledonia' },
  NZ: { id: 'NZ', country_name: 'New Zealand' },
  NI: { id: 'NI', country_name: 'Nicaragua' },
  NE: { id: 'NE', country_name: 'Niger' },
  NG: { id: 'NG', country_name: 'Nigeria' },
  NU: { id: 'NU', country_name: 'Niue' },
  NF: { id: 'NF', country_name: 'Norfolk Island' },
  KP: { id: 'KP', country_name: 'North Korea' },
  MP: { id: 'MP', country_name: 'Northern Mariana Islands' },
  NO: { id: 'NO', country_name: 'Norway' },
  OM: { id: 'OM', country_name: 'Oman' },
  PK: { id: 'PK', country_name: 'Pakistan' },
  PW: { id: 'PW', country_name: 'Palau' },
  PS: { id: 'PS', country_name: 'Palestine, State of' },
  PA: { id: 'PA', country_name: 'Panama' },
  PG: { id: 'PG', country_name: 'Papua New Guinea' },
  PY: { id: 'PY', country_name: 'Paraguay' },
  PE: { id: 'PE', country_name: 'Peru' },
  PH: { id: 'PH', country_name: 'Philippines' },
  PN: { id: 'PN', country_name: 'Pitcairn' },
  PL: { id: 'PL', country_name: 'Poland' },
  PT: { id: 'PT', country_name: 'Portugal' },
  PR: { id: 'PR', country_name: 'Puerto Rico' },
  QA: { id: 'QA', country_name: 'Qatar' },
  RE: { id: 'RE', country_name: 'Réunion' },
  RO: { id: 'RO', country_name: 'Romania' },
  RU: { id: 'RU', country_name: 'Russia' },
  RW: { id: 'RW', country_name: 'Rwanda' },
  BL: { id: 'BL', country_name: 'Saint Barthélemy' },
  SH: {
    id: 'SH',
    country_name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  KN: { id: 'KN', country_name: 'Saint Kitts and Nevis' },
  LC: { id: 'LC', country_name: 'Saint Lucia' },
  MF: { id: 'MF', country_name: 'Saint Martin (French part)' },
  PM: { id: 'PM', country_name: 'Saint Pierre and Miquelon' },
  VC: { id: 'VC', country_name: 'Saint Vincent and the Grenadines' },
  WS: { id: 'WS', country_name: 'Samoa' },
  SM: { id: 'SM', country_name: 'San Marino' },
  ST: { id: 'ST', country_name: 'Sao Tome and Principe' },
  SA: { id: 'SA', country_name: 'Saudi Arabia' },
  SN: { id: 'SN', country_name: 'Senegal' },
  RS: { id: 'RS', country_name: 'Serbia' },
  SC: { id: 'SC', country_name: 'Seychelles' },
  SL: { id: 'SL', country_name: 'Sierra Leone' },
  SG: { id: 'SG', country_name: 'Singapore' },
  SX: { id: 'SX', country_name: 'Sint Maarten (Dutch part)' },
  SK: { id: 'SK', country_name: 'Slovakia' },
  SI: { id: 'SI', country_name: 'Slovenia' },
  SB: { id: 'SB', country_name: 'Solomon Islands' },
  SO: { id: 'SO', country_name: 'Somalia' },
  ZA: { id: 'ZA', country_name: 'South Africa' },
  GS: {
    id: 'GS',
    country_name: 'South Georgia and the South Sandwich Islands',
  },
  KR: { id: 'KR', country_name: 'South Korea' },
  SS: { id: 'SS', country_name: 'South Sudan' },
  ES: { id: 'ES', country_name: 'Spain' },
  LK: { id: 'LK', country_name: 'Sri Lanka' },
  SD: { id: 'SD', country_name: 'Sudan' },
  SR: { id: 'SR', country_name: 'Suriname' },
  SJ: { id: 'SJ', country_name: 'Svalbard and Jan Mayen' },
  SZ: { id: 'SZ', country_name: 'Swaziland' },
  SE: { id: 'SE', country_name: 'Sweden' },
  CH: { id: 'CH', country_name: 'Switzerland' },
  SY: { id: 'SY', country_name: 'Syria' },
  TW: { id: 'TW', country_name: 'Taiwan' },
  TJ: { id: 'TJ', country_name: 'Tajikistan' },
  TZ: { id: 'TZ', country_name: 'Tanzania' },
  TH: { id: 'TH', country_name: 'Thailand' },
  TL: { id: 'TL', country_name: 'Timor-Leste' },
  TG: { id: 'TG', country_name: 'Togo' },
  TK: { id: 'TK', country_name: 'Tokelau' },
  TO: { id: 'TO', country_name: 'Tonga' },
  TT: { id: 'TT', country_name: 'Trinidad and Tobago' },
  TN: { id: 'TN', country_name: 'Tunisia' },
  TR: { id: 'TR', country_name: 'Turkey' },
  TM: { id: 'TM', country_name: 'Turkmenistan' },
  TC: { id: 'TC', country_name: 'Turks and Caicos Islands' },
  TV: { id: 'TV', country_name: 'Tuvalu' },
  UG: { id: 'UG', country_name: 'Uganda' },
  UA: { id: 'UA', country_name: 'Ukraine' },
  AE: { id: 'AE', country_name: 'United Arab Emirates' },
  GB: { id: 'GB', country_name: 'United Kingdom' },
  UM: { id: 'UM', country_name: 'United States Minor Outlying Islands' },
  US: { id: 'US', country_name: 'United States of America' },
  UY: { id: 'UY', country_name: 'Uruguay' },
  UZ: { id: 'UZ', country_name: 'Uzbekistan' },
  VU: { id: 'VU', country_name: 'Vanuatu' },
  VE: { id: 'VE', country_name: 'Venezuela' },
  VN: { id: 'VN', country_name: 'Vietnam' },
  VG: { id: 'VG', country_name: 'Virgin Islands (British)' },
  VI: { id: 'VI', country_name: 'Virgin Islands (U.S.)' },
  WF: { id: 'WF', country_name: 'Wallis and Futuna' },
  EH: { id: 'EH', country_name: 'Western Sahara' },
  YE: { id: 'YE', country_name: 'Yemen' },
  ZM: { id: 'ZM', country_name: 'Zambia' },
  ZW: { id: 'ZW', country_name: 'Zimbabwe' },
}
